"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var Logger_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const chalk_1 = __importDefault(require("chalk"));
const LoggingPrefix_1 = require("../enums/logger/LoggingPrefix");
let Logger = Logger_1 = class Logger {
    constructor(options) {
        this.options = options;
    }
    static log(loggingLevelColor, loggingPrefix, loggingMessage, value) {
        const processedMessage = loggingLevelColor(`\n${loggingPrefix} ${loggingMessage}`);
        console.log(processedMessage, value !== null && value !== void 0 ? value : '');
    }
    info(loggingMessage, value) {
        if (!this.options.log) {
            return;
        }
        Logger_1.log(Logger_1.colorInfo, LoggingPrefix_1.LoggingPrefix.Base, loggingMessage, value);
    }
    success(loggingMessage, value) {
        if (!this.options.log) {
            return;
        }
        Logger_1.log(Logger_1.colorSuccess, LoggingPrefix_1.LoggingPrefix.Base, loggingMessage, value);
    }
    warn(loggingMessage, value) {
        if (!this.options.log) {
            return;
        }
        Logger_1.log(Logger_1.colorWarn, LoggingPrefix_1.LoggingPrefix.Base, loggingMessage, value);
    }
    advertise(loggingMessage) {
        Logger_1.log(Logger_1.colorInfo, LoggingPrefix_1.LoggingPrefix.Base, loggingMessage);
    }
};
exports.Logger = Logger;
Logger.colorInfo = chalk_1.default.cyan;
Logger.colorSuccess = chalk_1.default.green;
Logger.colorWarn = chalk_1.default.yellow;
exports.Logger = Logger = Logger_1 = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Object])
], Logger);
